[
    {
        "title": "WOMEN",
        "subcategories": [
            {
                "title": "New Arrivals",
                "subcategories": [
                    {
                        "title": "New This Week",
                        "url": "/shop/new-this-week?optionId=7&title=New This Week&gender=female"
                    },
                    {
                        "title": "New This Month",
                        "url": "/shop/new-this-month?optionId=8&title=New This Month&gender=female"
                    },
                    {
                        "title": "All New Arrivals",
                        "url": "/shop/all-new-arrivals?optionId=1&title=All New Arrivals&gender=female"
                    }
                ]
            },
            {
                "title": "Shop By",
                "subcategories": [
                    {
                        "title": "For You",
                        "url": "/shop/for-you?optionId=3&title=For You&gender=female"
                    },
                    {
                        "title": "The Edit",
                        "url": "/edit?gender=female"
                    },
                    {
                        "title": "Shoppable Videos",
                        "url": "/videos?gender=female"
                    },
                    {
                        "title": "Trending Now",
                        "url": "/shop/trending?optionId=6&gender=female&title=Trending Now"
                    }
                ]
            },
            {
                "title": "Designers",
                "url": "/designers?gender=female"
            },
            {
                "title": "Clothing",
                "url": "/shop/clothing?page=1&title=Clothing",
                "subcategories": [
                    {
                        "title": "All Clothing",
                        "url": "/shop/clothing?page=1&title=Clothing"
                    },
                    {
                        "title": "Dresses",
                        "url": "/shop/clothing?gender=female&filters=category%3Ddresses&page=1&title=Clothing"
                    },
                    {
                        "title": "Tops",
                        "url": "/shop/clothing?gender=female&filters=category%3Dtops&page=1&title=Clothing"
                    },
                    {
                        "title": "Knitwear",
                        "url": "/shop/clothing?gender=female&filters=category%3Dknitwear&page=1&title=Clothing"
                    },
                    {
                        "title": "Coats & Jackets",
                        "url": "/shop/clothing?gender=female&filters=category%3Dcoats-and-jackets&page=1&title=Clothing"
                    },
                    {
                        "title": "Jeans",
                        "url": "/shop/clothing?gender=female&filters=category%3Ddenim&page=1&title=Clothing"
                    },
                    {
                        "title": "Pants",
                        "url": "shop/clothing?gender=female&filters=category%3Dbottoms&page=1&title=Clothing"
                    },
                    {
                        "title": "Skirts",
                        "url": "shop/clothing?gender=female&filters=category%3Dskirts&page=1&title=Clothing"
                    },
                    {
                        "title": "Shorts",
                        "url": "shop/clothing?gender=female&filters=category%3Dshorts&page=1&title=Clothing"
                    },
                    {
                        "title": "Lingerie",
                        "url": "/shop/all-new-arrivals?optionId=1&title=All+New+Arrivals&gender=female&filters=parent-category%3Dlingerie&page=1&title=Clothing"
                    },
                    {
                        "title": "Swimwear",
                        "url": "/shop/clothing?page=1&title=Clothing&filters=category%3Dswimwear-and-beachwear"
                    },
                    {
                        "title": "Matching Sets",
                        "url": "/shop/clothing?page=1&title=Clothing&filters=category%3Dmatching-seperates"
                    }
                ]
            },
            {
                "title": "Shoes",
                "url": "/shop/shoes?page=1&title=Shoes",
                "subcategories": [
                    {
                        "title": "All Shoes",
                        "url": "/shop/shoes?page=1&title=Shoes"
                    },
                    {
                        "title": "Boots",
                        "url": "/shop/shoes?page=1&title=Shoes&filters=category%3Dboots"
                    },
                    {
                        "title": "Pumps",
                        "url": "/shop/shoes?page=1&title=Shoes&filters=category%3Dpumps"
                    },
                    {
                        "title": "Sandals",
                        "url": "/shop/shoes?page=1&title=Shoes&filters=category%3Dsandals"
                    },
                    {
                        "title": "Flats",
                        "url": "/shop/shoes?page=1&title=Shoes&filters=category%3Dflat-shoes"
                    }
                ]
            },
            {
                "title": "Bags",
                "url": "/shop/bags?page=1&title=Bags",
                "subcategories": [
                    {
                        "title": "All Bags",
                        "url": "/shop/bags?page=1&title=Bags"
                    },
                    {
                        "title": "Shoulder Bag",
                        "url": "/shop/bags?page=1&title=Bags&filters=category%3Dshoulder-bags"
                    },
                    {
                        "title": "Tote Bag",
                        "url": "/shop/bags?page=1&title=Bags&filters=category%3Dtote-bags"
                    },
                    {
                        "title": "Mini Bags",
                        "url": "/shop/bags?page=1&title=Bags&filters=category%3Dmini-bags"
                    },
                    {
                        "title": "Cross-Body Bags",
                        "url": "/shop/bags?page=1&title=Bags&filters=category%3Dcross-body-bags"
                    },
                    {
                        "title": "Clutch Bags",
                        "url": "/shop/bags?page=1&title=Bags&filters=category%3Dclutch-bags"
                    }
                ]
            },
            {
                "title": "Jewelry & Watches",
                "url": "/shop/jewelry-&-watches?page=1&title=Jewelry %26 Watches",
                "subcategories": [
                    {
                        "title": "All Jewelry",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry %26 Watches"
                    },
                    {
                        "title": "Fine Jewelry",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry+%26+Watches&filters=category%3Dfine-jewelry"
                    },
                    {
                        "title": "Watches",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry+%26+Watches&filters=category%3Dwatches"
                    },
                    {
                        "title": "Earrings",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry+%26+Watches&filters=category%3Dearrings"
                    },
                    {
                        "title": "Necklaces",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry+%26+Watches&filters=category%3Dnecklaces"
                    },
                    {
                        "title": "Bracelets",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry+%26+Watches&filters=category%3Dbracelets"
                    },
                    {
                        "title": "Rings",
                        "url": "/shop/jewelry-&-watches?page=1&title=Jewelry+%26+Watches&filters=category%3Drings"
                    }
                ]
            },
            {
                "title": "Accessories",
                "url": "/shop/accessories?page=1&title=Accessories",
                "subcategories": [
                    {
                        "title": "All Accessories",
                        "url": "/shop/accessories?page=1&title=Accessories"
                    },
                    {
                        "title": "Sunglasses",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dsunglasses"
                    },
                    {
                        "title": "Wallets",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dwallets-%2526-cardholders"
                    },
                    {
                        "title": "Belts",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dbelts"
                    },
                    {
                        "title": "Hats",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dhats~hats-%2526-caps"
                    },
                    {
                        "title": "Gloves",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dgloves"
                    },
                    {
                        "title": "Scarves",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dscarves-and-wraps"
                    },
                    {
                        "title": "Hair Accessories",
                        "url": "/shop/accessories?page=1&title=Accessories&filters=category%3Dhair-accessories"
                    }
                ]
            },
            {
                "title": "Beauty",
                "url": "/shop/beauty?page=1&title=Beauty",
                "subcategories": [
                    {
                        "title": "All Beauty",
                        "url": "/shop/beauty?page=1&title=Beauty"
                    },
                    {
                        "title": "Bath & Body",
                        "url": "/shop/beauty?page=1&title=Beauty&filters=category%3Dbath-and-body"
                    },
                    {
                        "title": "Fragrance",
                        "url": "/shop/beauty?page=1&title=Beauty&filters=category%3Dhome-fragrance"
                    },
                    {
                        "title": "Skincare",
                        "url": "/shop/beauty?page=1&title=Beauty&filters=category%3Dmakeup"
                    },
                    {
                        "title": "Makeup",
                        "url": "/shop/beauty?page=1&title=Beauty&filters=category%3Dmakeup"
                    },
                    {
                        "title": "Tools and Devices",
                        "url": "/shop/beauty?page=1&title=Beauty&filters=category%3Dbeauty-cases"
                    }
                ]
            },
            {
                "title": "Home",
                "url": "/shop/home?page=1&title=Home",
                "subcategories": [
                    {
                        "title": "All Home",
                        "url": "/shop/home?page=1&title=Home"
                    },
                    {
                        "title": "Bath",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dbath"
                    },
                    {
                        "title": "Bedding",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dbedding"
                    },
                    {
                        "title": "Cookware & Bakeware",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dcookware-%2526-bakeware"
                    },
                    {
                        "title": "Candles & Room Fragrance",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dcandles-and-room-fragrance"
                    },
                    {
                        "title": "Home Fragrances",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dhome-fragrances"
                    },
                    {
                        "title": "Gifts",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dgifts"
                    },
                    {
                        "title": "Tableware",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dtableware"
                    },
                    {
                        "title": "Table Linens",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dtable-linens"
                    },
                    {
                        "title": "Throws and Cushions",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dthrows-and-cushions"
                    },
                    {
                        "title": "Towels",
                        "url": "/shop/home?page=1&title=Home&filters=category%3Dtowels"
                    }
                ]
            },
            {
                "title": "AI Stylist Search",
                "url": "/ai-stylist"
            },
            {
                "title": "Concierge Services",
                "subcategories": [
                    {
                        "title": "Digital Closet"
                    },
                    {
                        "title": "Outfit"
                    },
                    {
                        "title": "White Glove Digitization",
                        "url": "/white-glove-digitization?gender=female"
                    }
                ]
            }
        ]
    }
]
